import { useLocation, useNavigate } from 'react-router-dom';
import Navigation from './Navigation'
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setMenuListAssetInventory } from 'Store/AssetInventory/Navigation/NavigationAction';
import { ASSET_INVENTORY_CONSTANTS } from 'client/utils/constants/assetInventory';
import permissions, { isAuthorized } from 'client/utils/Permissions';
import userProfileSelectors from '../../../../../src/redux/UserProfile/selectors';

const NavigationContainer = () => {
  
  const ref: any = useRef(null)
  const path = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const pathName = path?.pathname?.split("/")[2];

  const { menuListAssetInventory, userDetails}: any = useSelector((state?: any) => ({
    menuListAssetInventory: state.AssetInventoryNavReducer.menuListAssetInventory,
    userDetails: userProfileSelectors.getUserDetails(state),
  }));

  let menuList = [
    {
      id:1,
      text: 'Users',
      Item: 'users',
      icon: 'users-icon',
      Title: 'Users',
      activeToggle: true
    }
  ]

  if (isAuthorized(permissions?.CreateAssessment) || isAuthorized(permissions?.ViewAssessment)) {
    menuList.push(
      {
        id: 2,
        text: 'Question',
        Item: 'questions',
        icon: 'question-icon',
        Title: 'Question',
        activeToggle: false
      }
    )
  }

  if (isAuthorized(permissions?.CreateEditAudit) || isAuthorized(permissions?.ViewAudit)) {
    menuList.push(
      {
        id: 3,
        text: 'Audit Dates',
        Item: 'auditdates',
        icon: 'auditdates-icon',
        Title: 'Audit Dates',
        activeToggle: false
      },
    )
  }

  if (isAuthorized(permissions?.ViewMAScanning)) {
    menuList.push(
      {
        id: 4,
        text: 'M&A Scan',
        Item: 'mergerandacquisitionscan',
        icon: 'mergerandacquisitionscan-icon',
        Title: 'M&A Scan',
        activeToggle: false
      }
    )
  }
  if (isAuthorized(permissions?.View_AssetAuditReadinessWB)) {
    menuList.push(
      {
        id: 5,
        text: 'Asset Inventory',
        Item: 'assetInventoryReadiness',
        icon: 'assetinventory-icon',
        Title: 'Asset Inventory',
        activeToggle: false
      }
    )
  }

  useEffect(()=>{
    dispatch(setMenuListAssetInventory(menuList))
  },[userDetails?.permissions])

  const handleClick = (dataItem: any) => {
    
   if(dataItem.Item === 'users') {
    navigate('assetinventory')
   }
   else {
    navigate('assetinventory/'+dataItem.Item)
   }   
   
  menuListAssetInventory.forEach((item:any)=>{
      if(item.text === dataItem.text){
          item.activeToggle = true
      }
      else{
          item.activeToggle = false
      }
  })
  dispatch(setMenuListAssetInventory(menuListAssetInventory))
  }
  
  useEffect(()=>{
    if (pathName === ASSET_INVENTORY_CONSTANTS.QUESTIONS && menuListAssetInventory?.length) {
      menuListAssetInventory.forEach((item: any) => {
        item.activeToggle = item.id == 2;
      })
    } else if(pathName === ASSET_INVENTORY_CONSTANTS.AUDIT_DATES && menuListAssetInventory?.length){
      menuListAssetInventory.forEach((item: any) => {
          item.activeToggle = item.id == 3;
      })
    } else if(pathName === ASSET_INVENTORY_CONSTANTS.MERGER_AND_ACQUISITION && menuListAssetInventory?.length){
      menuListAssetInventory.forEach((item: any) => {
          item.activeToggle = item.id == 4;
      })
    } else if(pathName === ASSET_INVENTORY_CONSTANTS.ASSETINVENTORYREADINESS && menuListAssetInventory?.length){
      menuListAssetInventory.forEach((item: any) => {
          item.activeToggle = item.id == 5;
      })
    } else {
      menuListAssetInventory.forEach((item: any) => {
          item.activeToggle = item.id == 1;
      })
    }
  },[pathName, menuListAssetInventory])

  return <Navigation 
    handleClick={handleClick} 
    menuListAssetInventory={menuListAssetInventory} 
    wrapperRef={ref}
  />

}

export default NavigationContainer
